var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstitutionArrow01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "ml-1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7496 1.49561L4.60452 4.74339C4.27065 5.08553 3.72935 5.08553 3.39548 4.74339L0.250401 1.49561C-0.0834662 1.15347 -0.0834661 0.598745 0.250401 0.256604C0.584269 -0.0855362 1.12558 -0.0855361 1.45944 0.256605L4 2.88489L6.54056 0.256605C6.87442 -0.0855356 7.41573 -0.0855356 7.7496 0.256605C8.08347 0.598746 8.08347 1.15347 7.7496 1.49561Z",
    fill: "#151515",
    className: "hc-arrow"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutionArrow01);
export default __webpack_public_path__ + "static/media/institution-arrow-01.b94b7dd75e96d7b815f95712f1d69ccc.svg";
export { ForwardRef as ReactComponent };